/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import store from '../state/store';

store.on('enquiry:address:update', function(address_id, params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/addresses/${address_id}`,
    type: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      const ui_enquiry = store.get().ui.enquiry;
      const enquiry_id = ui_enquiry.id;
      const { lesson_plan_id } = ui_enquiry;

      if (lesson_plan_id) {
        store.emit('enquiry:lesson_plans:show', enquiry_id, lesson_plan_id);
        return store.emit('lesson_plan:tutor_results:index', lesson_plan_id);
      }
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});
function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}